// extracted by mini-css-extract-plugin
export var arrowIcon = "TextLink-module--arrowIcon--3621c";
export var arrowUpAndDown = "TextLink-module--arrow-up-and-down--09ed4";
export var iconHidden = "TextLink-module--iconHidden--d633b";
export var iconRight = "TextLink-module--iconRight--ab287";
export var link = "TextLink-module--link--7340a";
export var withArrowIcon = "TextLink-module--withArrowIcon--adfef";